import script from "./mobile-tools-nav-link.vue?vue&type=script&setup=true&lang=ts"
export * from "./mobile-tools-nav-link.vue?vue&type=script&setup=true&lang=ts"

import "./mobile-tools-nav-link.vue?vue&type=style&index=0&id=65b6bee8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65b6bee8"]])

export default __exports__